<script>
import { h, resolveComponent } from 'vue';

export default {
  name: 'cClipboard',
  emits:['clipboard'],
  data() {
    return {};
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    toastText: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {
    copyToClipboard(param) {
      const t = document.createElement('textarea');
      document.body.appendChild(t);
      t.value = param;
      t.select();
      document.execCommand('copy');
      document.body.removeChild(t);
    },
    onClipboard() {
      this.copyToClipboard(this.text);
      this.$toast.open(this.toastText);
      this.$emit('clipboard', this.text);
    }
  },
  render() {
    const legoIcon = resolveComponent('lego-icon');
    const cLabel = resolveComponent('c-label');
    return h(
      'div',
      {
        class: { 'c-clipboard': true }
      },
      [
        h(
          cLabel,
          {
            inline: true
          },
          [this.text]
        ),
        this.text &&
          h(legoIcon, {
            iconType: 'df',
            icon: 'copy',
            size: 16,
            id: 'manual',
            onClick: this.onClipboard
          })
      ]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-clipboard {
  :deep(.c-label) {
    margin-right: 7px;
  }

  :deep(.opus-icon__copy) {
    position: relative;
    top: 2px;
  }
}
</style>
